package org.hs_soft.runmynesto.domain

import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.modules.Sentry
import org.koin.core.component.getScopeName

suspend fun <T> requestHandler(
    condition: Boolean = true,
    loadingState: (Boolean) -> Unit = {},
    callRequest: suspend () -> T,
    onSuccess: (T) -> Unit,
    onError: (T) -> Unit = {},
    onException: (Exception) -> Unit = {},
){
    if (condition) {
        loadingState(true)
        try {
            val result = callRequest()
            val dynamicResult = result.asDynamic().toString()
 
            if (dynamicResult.contains("errors=[")) {
                onError(result)
            } else {
                onSuccess(result)
            }
            loadingState(false)
        } catch (e: Exception) {
            onException(e)
            checkSentry(e)
        } finally {
            loadingState(false)
        }
    }
}

fun errorMessage(errs: List<GeneralError?>?):String{
    return errs?.getOrNull(0)?.message?.substringBefore(". RequestId")?:""
}

private fun checkSentry(
    error: Exception,
) {
    Sentry.captureException(error)
    console.log(error.toString())
}

